import { ROUTES } from '@openclassrooms/routing';
import { useCurrentUserContext } from '@openclassrooms/data-connect-web/users';

import { Route, Routes } from 'react-router-dom';
import CourseExerciseContextProvider from '../contexts/CourseExerciseContextProvider';
import CourseContextProvider from '../contexts/CourseContextProvider';
import CourseChapterContextProvider from '../contexts/CourseChapterContextProvider';
import CourseChapterScreen from './CourseChapterScreen';
import CourseHomeScreen from './CourseHomeScreen';
import CourseExerciseScreen from './CourseExerciseScreen';
import CourseExerciseScreenAnonymous from './CourseExerciseScreenAnonymous';

const withoutBaseRoute = (route: string) => route.replace(ROUTES.COURSES.INDEX, '');

export default function Routing() {
  const { isConnected, isLoading: isLoadingCurrentUser } = useCurrentUserContext();

  return (
    <Routes>
      <Route
        path={withoutBaseRoute(ROUTES.COURSES.DETAIL)}
        element={
          <CourseContextProvider>
            <CourseHomeScreen />
          </CourseContextProvider>
        }
      />

      <Route
        path={withoutBaseRoute(ROUTES.COURSES.CHAPTERS)}
        element={
          <CourseContextProvider>
            <CourseChapterContextProvider>
              <CourseChapterScreen />
            </CourseChapterContextProvider>
          </CourseContextProvider>
        }
      />

      <Route
        path={withoutBaseRoute(ROUTES.COURSES.EXERCISES)}
        element={
          <>
            {isConnected || isLoadingCurrentUser ? (
              <CourseContextProvider>
                <CourseExerciseContextProvider>
                  <CourseExerciseScreen />
                </CourseExerciseContextProvider>
              </CourseContextProvider>
            ) : (
              <CourseContextProvider>
                <CourseExerciseScreenAnonymous />
              </CourseContextProvider>
            )}
          </>
        }
      />
    </Routes>
  );
}
